import { render, staticRenderFns } from "./PaymentPreLoading.vue?vue&type=template&id=fb9d99c2&scoped=true"
import script from "./PaymentPreLoading.vue?vue&type=script&lang=js"
export * from "./PaymentPreLoading.vue?vue&type=script&lang=js"
import style0 from "./PaymentPreLoading.vue?vue&type=style&index=0&id=fb9d99c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d99c2",
  null
  
)

export default component.exports